import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { matchPath, useSearchParams } from 'react-router-dom';
import { Spinner, H2, Text, Link, Logo, useLocalizeMessage } from 'libs.nucleus';
import { AuthContext, AuthRoute } from '../../features';
// Whitelist of Auth routes that are accessible while authenticated
const routeWhitelist = [AuthRoute.SWITCH_WORKSPACE];
/**
 * This is a generic component that wraps the auth forms
 * it is the intention to use this wrapper to construct any authentication page like login, forgot password, etc.
 */
export const AuthWrapper = ({ children, onSubmit, title, showSupportFooter, }) => {
    const translate = useLocalizeMessage();
    const [searchParams] = useSearchParams();
    const { isLoading, isLoggedIn, mfaChallenge, redirectToDefaultPage } = useContext(AuthContext);
    const isOnWhitelistedRoute = routeWhitelist.some((route) => matchPath({ path: route, caseSensitive: false, end: false }, location.pathname));
    useEffect(() => {
        if (!isLoading && isLoggedIn && !mfaChallenge && searchParams.get('expired-session') !== 'true') {
            if (isOnWhitelistedRoute) {
                return;
            }
            redirectToDefaultPage();
        }
    }, [isLoggedIn, isLoading, mfaChallenge]);
    const handleOnSubmit = (event) => {
        event.preventDefault();
        onSubmit?.();
    };
    return (_jsxs("form", { className: 'flex flex-col text-center items-center justify-center h-screen gap-6 bg-background p-2', onSubmit: handleOnSubmit, children: [_jsx("div", { className: 'h-[54px] w-[220px]', children: _jsx(Logo, {}) }), title && _jsx(H2, { children: title }), _jsxs("section", { className: 'relative flex flex-col rounded-lg bg-surface shadow-md p-6 max-w-[30rem] w-full', children: [(isLoading || (isLoggedIn && !mfaChallenge && !isOnWhitelistedRoute)) && (_jsx("section", { "data-testid": 'auth-wrapper-loading', className: 'absolute inset-0 z-10 flex items-center justify-center bg-surface/60', children: _jsx(Spinner, {}) })), children] }), showSupportFooter && (_jsxs("div", { className: 'flex items-center justify-center gap-2', children: [_jsx(Text, { size: 'sm', className: 'text-secondary', children: translate('Need help?') }), _jsx(Link, { href: 'https://www.medable.com/company/support', target: '_blank', children: translate('Contact Medable support') })] }))] }));
};
